import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useReturnReasonsAnalytics from "@babackapp/private-api-client/client/use-return-reasons-analytics";
import { useMemo } from "react";
import { useDashboardFilters } from "../lib/dashboard-filters";
import useTextDtoValue from "@/utils/use-text-dto-value";

export function useReasonText(reasonId: string | undefined): string {
  const { data: shop } = useCurrentShopSuspense();
  const { fromTimestamp, toTimestamp, productId, variantId, resolution } = useDashboardFilters();

  const { data: reasonsData } = useReturnReasonsAnalytics({
    shopId: shop?.id,
    fromTimestamp: fromTimestamp ?? 0,
    toTimestamp: toTimestamp ?? 0,
    productId,
    variantId,
    resolution,
  });

  const selectedReason = useMemo(() => {
    if (!reasonId || !reasonsData) return null;
    return reasonsData.find(reason => reason.id === reasonId);
  }, [reasonsData, reasonId]);

  const reasonText = useTextDtoValue(selectedReason?.values);

  return reasonText || reasonId || "N/A";
}
